import React, { useEffect, useState } from "react";
import FirstStageTemplate from "../../../Templetes/Registration/FirstStage/FirstStage.template";
import useSave from "../../../Hooks/useSave";
import {
  applicationURL,
  countriesURL,
  categoriesURL,
  organizationsURL,
  firstStageURL,
} from "../../../Hooks/URL";
import useFetch from "../../../Hooks/useFetch";
import { Fetch } from "../../../Hooks/Fetch";
import { useNavigate } from "react-router";

const FirstStagePage = () => {
  const navigate = useNavigate();
  const [country, setCountry] = useState({ target: { value: 42 } });
  const [cities, setCities] = useState([]);
  const [newObject, setNewObject] = useState({});
  const [newObjectConfirm, setNewObjectConfirm] = useState({});
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [feesOpen, setFeesOpen] = useState(false);
  const [goSave, setGoSave] = useState(false);
  const [FinalSave, setFinalSave] = useState(false);
  const [userType, setuserType] = useState("organization");

  const handleType = (event, newType) => {
    setuserType(newType);
  };

  const { data: countriesList, loading: countriesLoading } =
    useFetch(countriesURL);
  const { data: organizationsList, loading: organizationsLoading } =
    useFetch(organizationsURL);

  const { saveState, loading: addLoading } = useSave({
    url: `${firstStageURL}/confirmation`,
    goSave,
    setGoSave,
    newObject,
    popup: false,
  });

  const { saveState: finalState, loading: FinalLoading } = useSave({
    url: `${firstStageURL}`,
    goSave: FinalSave,
    setGoSave: setFinalSave,
    newObject,
  });

  useEffect(() => {
    if (country)
      Fetch(`${countriesURL}/${country?.target?.value}/cities`, setCities);
  }, [country]);

  useEffect(() => {
    if (newObjectConfirm && Object.keys(newObjectConfirm)?.length)
      setConfirmOpen(true);
  }, [newObjectConfirm]);

  useEffect(() => {
    if (!addLoading && saveState?.dataRes?.data) {
      setNewObjectConfirm(saveState?.dataRes?.data?.data);
    }
  }, [addLoading, goSave, saveState]);

  useEffect(() => {
    if (finalState?.dataRes?.data && !FinalLoading) {
      setConfirmOpen(false);
      navigate(`/firststage/registered`, {
        state: { application: finalState?.dataRes?.data?.data },
      });
    }
  }, [FinalLoading, finalState]);

  useEffect(() => {
    document.title = "International Robot Challenge - First Stage Application";
  }, []);

  return (
    <FirstStageTemplate
      newObject={newObject}
      setNewObject={setNewObject}
      setGoSave={setGoSave}
      setFinalSave={setFinalSave}
      confirmOpen={confirmOpen}
      setConfirmOpen={setConfirmOpen}
      addLoading={addLoading}
      countriesList={countriesList?.data ?? []}
      organizationsList={organizationsList?.data ?? []}
      newObjectConfirm={newObjectConfirm}
      setCountry={setCountry}
      cities={cities}
      FinalLoading={FinalLoading}
      feesOpen={feesOpen}
      setFeesOpen={setFeesOpen}
      userType={userType}
      handleType={handleType}
    />
  );
};

export default FirstStagePage;
